/**
 * 
 * @file Preview loading and error UI wrapper
 * @author Box
 */

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'box-react-ui/lib/components/button/Button';
import { Notification, NotificationConstants } from 'box-react-ui/lib/components/notification';
import messages from '../messages';


var ReloadNotification = function ReloadNotification(_ref) {
    var onClick = _ref.onClick,
        onClose = _ref.onClose;
    return React.createElement(
        'span',
        { className: 'bcpr-notification' },
        React.createElement(
            Notification,
            { type: NotificationConstants.TYPE_INFO, onClose: onClose },
            React.createElement(FormattedMessage, messages.previewUpdate),
            React.createElement(
                Button,
                { onClick: onClick },
                React.createElement(FormattedMessage, messages.reload)
            )
        )
    );
};

export default ReloadNotification;